import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { UserMetaDataService } from '../../services/user-service';
import { SystemConfigService } from '../../services/system-config.service';

@Component({
    selector: 'app-header',
    imports: [CommonModule, ButtonModule],
    templateUrl: './header.html',
    styleUrl: './header.scss',
})
export class Header {
    readonly userService = inject(UserMetaDataService);
    readonly systemConfig = inject(SystemConfigService);

    @Input() hasMatrix = false;

    @Input() locked = false;

    @Output() validate = new EventEmitter<void>();

    @Output() finalize = new EventEmitter<void>();

    @Output() reopen = new EventEmitter<void>();
}
